<template>
  <li class="col-12 overview-item listed-search-article" data-mm-load-item="">
    <div class="card">
      <div class="link card-link">
        <div class="row">
          <div class="col-12">
            <div class="card-body">
              <div class="card-title">
                <h2 class="card-title-heading">
                  <span class="row">
                    <span class="col-12 col-md-9">
                      {{ (item && item['course_title_t'] && item['course_title_t'][0]) || "Kurs" }} <template v-if="item && item['course_code_t'] && item['course_code_t'][0]">({{ item['course_code_t'][0] }})</template>
                    </span>
                  </span>
                </h2>
              </div>
              <p v-if="highlight" v-html="sanitizeHtml(`&hellip;&nbsp;${highlight}&nbsp;&hellip;`)" class="card-text"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2" v-for="(itemId, index) in (item && item['course_training_id_ss'] || [])" v-bind:key="index">
        <div class="col-12 col-md-4">
          <p class="breadcrumb mb-0 py-0" v-if="item && item['course_training_end_dts'] && item['course_training_end_dts'][index] && isOpenEndDate(item['course_training_end_dts'][index])">
            Termin/e: Nach Vereinbarung
          </p>
          <p class="breadcrumb mb-0 py-0" v-else>
            Termin/e: {{ formatDate(item && item['course_training_start_dts'] && item['course_training_start_dts'][index] || '') }}<template v-if="item && item['course_training_end_dts'] && item['course_training_end_dts'][index]"> - {{ formatDate(item['course_training_end_dts'][index]) }}</template>
          </p>
        </div>
        <div class="col-12 col-md-4">
          <p class="breadcrumb mb-0 py-0 text-md-center w-100 d-md-block">
            <template v-if="item && item['course_formtype_t'] && item['course_formtype_t'][0]">{{ getFormText(item['course_formtype_t'][0]) }}</template>
          </p>
        </div>
        <div class="col-12 col-md-4 text-right py-0">
          <a :href="sanitizeUrl(url(index))" class="p-0 w-100 ml-auto breadcrumb no-underline text-primary d-flex align-items-center justify-content-end" target="_self">
            <span class="icon icon-navigation_pfeil_rechts" aria-hidden="true"></span>
            Details anzeigen
            <span class="sr-only">zum Seminar {{ (item && item['course_title_t'] && item['course_title_t'][0]) || "Kurs" }}
              <div v-if="item && item['course_training_end_dts'] && item['course_training_end_dts'][index] && isOpenEndDate(item['course_training_end_dts'][index])">
                (Termin nach Vereinbarung)
              </div>
              <div v-else>
                zum Termin {{ formatDate(item && item['course_training_start_dts'] && item['course_training_start_dts'][index] || '') }}<template v-if="item && item['course_training_end_dts'] && item['course_training_end_dts'][index]"> - {{ formatDate(item['course_training_end_dts'][index]) }}</template>
              </div>
            </span>
          </a>
        </div>
      </div>

    </div>
    <div class="badge" aria-hidden="true"></div>
  </li>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { formatDate } from '../../utils/dateUtils'
import { sanitizeUrl } from '@braintree/sanitize-url'
import { sanitizeHtml } from '@/utils/domUtils'
import moment from 'moment';

export default defineComponent({
  name: 'Page',
  props: {
    item: Object,
    highlight: String,
    nodeLink: Object,
    dependants: Object,
    ancestors: Object,
    badges: Object,
    detailUrl: String,
  },
  data() {
    return {
      sanitizeUrl: sanitizeUrl,
      sanitizeHtml: sanitizeHtml
    };
  },
  computed: {
  },
  methods: {
    url(index: number): string {
      try {
        if (this.item && this.item['course_id_s'] && (index >= 0 && this.item['course_training_id_ss'] && this.item['course_training_id_ss'][index])) {
          return this.detailUrl + "?vid=" + this.item['id'] + "&tid=" + this.item['course_training_id_ss'][index]
        } else if (this.item && this.item['course_id_s']) {
          return this.detailUrl + "?vid=" + this.item['id']
        }
      } catch (e) {
        // probably array index out of bounds
      }

      return '#'
    },
    getFormText(form: string) {
      switch (form) {
        case "Präsenz":
          return "Teilnahme: Präsenz"
        case "Online-Tr. / Webinar":
          return "Teilnahme: Online"
        default:
          return ""
      }
    },
    formatDate(date: string) {
      if (date) {
        return formatDate(date, 'DD.MM.yyyy')
      }
      return ""
    },
    isOpenEndDate(date: string) {
      try {
        moment.locale('de-AT')
        const momDate = moment(date)
        if (momDate.isValid() && momDate.year() === 9999) {
          return true;
        }
      } catch(error) {
        // nothing
      }
      return false;
    }
  }
});
</script>
<style scoped>
</style>
